var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreatePencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_779_3445)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.176 1.5729C18.0794 1.47608 17.9218 1.4751 17.8233 1.57358L16.0607 3.33622L18 5.27556L19.7627 3.51292C19.8595 3.41634 19.8612 3.25806 19.7627 3.15958L18.176 1.5729ZM6.46969 10.8059L14.463 2.81264L14.4697 2.80585L14.4765 2.79915L16.7627 0.51292C17.446 -0.170372 18.5539 -0.171575 19.2373 0.51292L20.8233 2.09892C21.5068 2.78241 21.5077 3.89083 20.8227 4.57426L10.5303 14.8666C10.4342 14.9627 10.3138 15.0309 10.1819 15.0639L6.18192 16.0639C5.92634 16.1278 5.65597 16.0529 5.46969 15.8666C5.2834 15.6803 5.20851 15.4099 5.27241 15.1543L6.27241 11.1543C6.30538 11.0225 6.37357 10.902 6.46969 10.8059ZM16.9394 6.33622L15 4.39688L7.67724 11.7197L7.03079 14.3055L9.61658 13.659L16.9394 6.33622ZM1.5 8.08618C1.5 6.29126 2.95507 4.83618 4.75 4.83618H9.25C9.66421 4.83618 10 4.5004 10 4.08618C10 3.67197 9.66421 3.33618 9.25 3.33618H4.75C2.12665 3.33618 0 5.46283 0 8.08618V17.0862C0 19.7095 2.12665 21.8362 4.75 21.8362H13.75C16.3734 21.8362 18.5 19.7095 18.5 17.0862V12.5862C18.5 12.172 18.1642 11.8362 17.75 11.8362C17.3358 11.8362 17 12.172 17 12.5862V17.0862C17 18.8811 15.5449 20.3362 13.75 20.3362H4.75C2.95507 20.3362 1.5 18.8811 1.5 17.0862V8.08618Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_779_3445"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreatePencil);
export default __webpack_public_path__ + "static/media/create-pencil.ef85d6a48a63cfb53b3ff96fb320db34.svg";
export { ForwardRef as ReactComponent };